import type { Components, Theme } from '@mui/material/styles';
import { base } from './base';
import { controls } from './controls';
import { data } from './data';
import { inputs } from './inputs';
import { surfaces } from './surfaces';

export const components: Components<Theme> = { ...base, ...controls, ...inputs, ...surfaces, ...data };
